export const WalletTransactionType = {
  CREDIT: "credit",
  DEBIT: "debit",
} as const;
export type WalletTransactionType =
  (typeof WalletTransactionType)[keyof typeof WalletTransactionType];
